/// REACT ///
import { Fragment } from "react";
/// MUI ///
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
/// STYLES ///
import { item_style } from "styles/quote_preview/section";

interface Props {
  name: string,
  subtotal: number
}

export default function QuoteSummaryHeader({ name, subtotal }: Props) {
  return (
    <Fragment>
      <Grid item xs={6}>
        <Typography variant="body2" sx={item_style()}>
          <b>{name}</b>
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2" align="right" sx={item_style()}>
          <b>{subtotal > 0 ? `$${subtotal.toFixed(2)}` : ""}</b>
        </Typography>
      </Grid>
    </Fragment>
  )
}
